export const environment = {
    production: false,
    API_URL: 'http://localhost:44392/api/',
    redirectUri: 'http://localhost:4200/',
    ruta_configuracion_reportes:"/68042ca76b35f94de11b4ae5/680432076b35f94de11b4ae6/680432ec6b35f94de11b4ae8",
    ruta_configuracion_mapeo:"/67f54c0f05c385f966d45453/67f54c7a05c385f966d45454/67f5c8e3694be7f5a61f429d",
    ruta_configuracion_reportesexcel:"/681d2521d8fa64102a18e550/681d25cdd8fa64102a18e551/681df8276bf601d9df8259ad",
    /** Configuración Microsoft Entra ID para zona Participantes */
    msalEntraId: {
        auth: {
            clientId: '37f5c6ae-7fac-4095-86f4-88809ce9c0f',
            authority: 'https://login.microsoftonline.com/3e720c4c-7345-411b-80c7-8186d1e2c010',
            redirectUri: 'http://localhost:4200/participantes',
            postLogoutRedirectUri: 'http://localhost:4200/participantes'
        },
        cache: {
            cacheLocation: 'sessionStorage' as const,
            storeAuthStateInCookie: false
        },
        scopes: ['Entrar_como_participante']
    }
};
